<script>
import LayoutEditor from '@layouts/editor.vue'
import { mapGetters, mapState } from 'vuex'
import WidgetDisplay from '@components/campaignSetup/WidgetDisplay.vue'

export default {
  page: {
    title: 'Display Settings',
    meta: [{ name: 'description', content: 'CampaignDisplay' }],
  },
  name: 'DisplayView',
  components: {
    LayoutEditor,
    'widget-display-settings-component': WidgetDisplay,
  },
  computed: {
    ...mapState({
      isCampaignLoaded: (state) => state.campaign.isCampaignLoaded,
    }),
    ...mapGetters('campaign/widget', ['targetWidget']),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('campaign/CAMPAIGN_CLEAR')
    this.$store.commit('campaign/widget/WIDGETS_CLEAR')
    this.$store.commit('campaign/contentItem/CONTENT_ITEM_CLEAR')
    next()
  },
}
</script>

<template>
  <LayoutEditor>
    <el-row id="setup-view">
      <div class="container">
        <el-row>
          <el-col :span="16">
            <h1 class="has-subheading">Display Settings</h1>
            <p>Final touches to your onvocado widget</p>
          </el-col>
        </el-row>

        <template v-if="isCampaignLoaded && targetWidget">
          <widget-display-settings-component :widget="targetWidget"/>
        </template>
        <template v-else>
          <Loader></Loader>
        </template>
      </div>
    </el-row>
  </LayoutEditor>
</template>